.title {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
}
.actions {
    display: flex;
    justify-content: center;
    color: black;
}
.animatedModal {
    will-change: transform;
    animation: slideUp 750ms cubic-bezier(0, 0.72, 0.24, 1.02);
    animation-delay: 3s;
}
@keyframes slideUp {
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0%);
    }
}
